import { Component, forwardRef, inject, signal, WritableSignal } from '@angular/core';
import { LocationDecisionAppEntityLocationDecisionWrite } from '../../../../../../../openapi';
import { LocationDecisionItemForm } from '../location-decision-item.form';
import { LocationDecisionsPreviewComponent } from '../location-decisions-preview/location-decisions-preview.component';
import { ParcelsPreviewComponent } from '../../parcels/parcels-preview/parcels-preview.component';
import { CommonModule, NgIf } from '@angular/common';
import {
  LocationDecisionItemFormComponent
} from '../location-decision-item-form/location-decision-item-form.component';
import { ParcelItemFormComponent } from '../../parcels/parcel-item-form/parcel-item-form.component';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-location-decisions-crud',
  standalone: true,
  imports: [
    LocationDecisionsPreviewComponent,
    ParcelsPreviewComponent,
    CommonModule,
    LocationDecisionItemFormComponent,
    ParcelItemFormComponent
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LocationDecisionsCrudComponent),
      multi: true
    },
    LocationDecisionItemForm
  ],
  templateUrl: './location-decisions-crud.component.html'
})
export class LocationDecisionsCrudComponent implements ControlValueAccessor {

  public itemForm: LocationDecisionItemForm = inject(LocationDecisionItemForm);

  public disabled = false;

  public locationDecisions: WritableSignal<LocationDecisionAppEntityLocationDecisionWrite[]> = signal<LocationDecisionAppEntityLocationDecisionWrite[]>([]);

  public showItemForm = false;
  public currentIndex: number | undefined;

  public onChange: any = () => {
  };

  public onTouch: any = () => {
  };

  writeValue(value: LocationDecisionAppEntityLocationDecisionWrite[]): void {
    this.locationDecisions.set(value);
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public onRemoveItem(index: number): void {
    this.locationDecisions.update(v => v.filter((_, i) => i !== index));
    this.onChange(this.locationDecisions());
  }

  public onCancelItemForm(): void {
    this.showItemForm = false;
    this.currentIndex = undefined;
    this.onChange(this.locationDecisions());
  }

  public onSubmitItemForm(value: LocationDecisionAppEntityLocationDecisionWrite): void {
    if (this.currentIndex !== undefined) {
      this.locationDecisions.update((v: LocationDecisionAppEntityLocationDecisionWrite[]) => {
        let items = [...v];
        if (this.currentIndex !== undefined) {
          items[this.currentIndex] = value;
        }
        return items;
      });
    } else {
      this.locationDecisions.update(v => [...v, value]);
    }
    this.showItemForm = false;
    this.currentIndex = undefined;
    this.onChange(this.locationDecisions());
  }

}
